import $ from "jquery";
window.$ = $;
window.jQuery = $;
window.jquery = $;

import bootstrap from "bootstrap/dist/js/bootstrap.min";
window.bootstrap = bootstrap;
